import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

import { EnvVar } from "@/env";
import useQuery from "@/hooks/useQuery";

type Auth0MtxProps = {
  children?: React.ReactNode;
};

const Auth0MtxProvider = ({ children }: Auth0MtxProps) => {
  const query = useQuery();
  const invitation = query.get("invitation");
  const authConfig = {
    domain: EnvVar.auth0PlatformDomain,
    clientId: EnvVar.auth0ClientId,
    audience: EnvVar.auth0Audience,
    orgId: EnvVar.auth0OrgId,
  };
  const history = useHistory();

  const onRedirectCallback = (appState?: AppState) => {
    history.push((appState && appState.returnTo) || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      authorizationParams={{
        scope: "read:current_user update:current_user_metadata profile email openid",
        redirect_uri: window.location.origin,
        audience: authConfig.audience,
        invitation: invitation ?? "",
        ...(authConfig.orgId ? { organization: authConfig.orgId } : {}),
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0MtxProvider;
